import type { useRouter } from "@tanstack/react-router";

import { useAuth } from "@workspace/auth-context";
import { ProfileProvider } from "@workspace/profile";

import { TenantContext, useTenantContext } from "./hooks";

export function TenantProvider({
	children,
	router,
	tenantMap = {},
	features,
	tenant: staticTenant,
	url,
	defaultSidebarOpen,
}: {
	children: React.ReactNode;
	router: ReturnType<typeof useRouter>;
	tenantMap?: Record<string, string>;
	features?: string[];
	tenant?: string;
	url?: boolean;
	defaultSidebarOpen?: boolean;
}) {
	const { userId, isAuthenticated } = useAuth();
	const tenant = useTenantContext({
		userId,
		isAuthenticated,
		router,
		tenantMap,
		features,
		tenant: staticTenant,
		url,
	});

	return (
		<TenantContext value={tenant}>
			<ProfileProvider
				router={router}
				values={{
					tenant: tenant.tenant,
					userId: userId,
					defaultSidebarOpen: defaultSidebarOpen ?? false,
				}}
			>
				{children}
			</ProfileProvider>
		</TenantContext>
	);
}
